<div *ngIf="history && history.length && !isLoading" class="bmc-previous-processes__container">
    <strong
        class="bmc-previous-processes__title bz-space--stack-s">{{'DEPLOYMENT.PREVIOUS_PROCESSES' | translate}}</strong>
    <div class="bmc-previous-processes__table">
        <table class="bz-table">
            <thead>
                <tr>
                    <th class="bz-table__cell">
                        {{'DEPLOYMENT.COLUMN_FILE_NAME' | translate}}
                    </th>
                    <th class="bz-table__cell">
                        {{'DEPLOYMENT.COLUMN_LOAD_STATUS' | translate}}
                    </th>
                    <th class="bz-table__cell">
                        {{'DEPLOYMENT.COLUMN_UPLOADED_BY' | translate}}
                    </th>
                    <th class="bz-table__cell">
                        {{'DEPLOYMENT.COLUMN_UPLOADED_STATE' | translate}}
                    </th>
                    <th class="bz-table__cell">
                        {{'DEPLOYMENT.COLUMN_UPLOADED_TIME' | translate}}
                    </th>
                    <th class="bz-table__cell">
                        <div class="bmc-previous-processes__icon-action">
                            {{'DEPLOYMENT.COLUMN_VIEW_CONTENT' | translate}}
                        </div>
                    </th>
                    <th class="bz-table__cell">
                        <div class="bmc-previous-processes__icon-action">
                            {{'DEPLOYMENT.COLUMN_DOWNLOAD' | translate}}
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let his of historyPaginated">
                    <td class="bz-table__cell bmc-previous-processes__cell-limit-width" [title]="his.Filename">
                        {{his.Filename}}
                    </td>
                    <td class="bz-table__cell">
                        <div class="bmc-previous-processes__status">
                            <bzg-icon [nameIcon]="'icon-warning'" [color]="'error'" class="bz-space--inline-s"
                                *ngIf="his.DescriptionStateBEX === 'Error'"></bzg-icon>
                            <bzg-icon [nameIcon]="'icon-check-mark'" [color]="'success'" class="bz-space--inline-s"
                                *ngIf="his.DescriptionStateBEX === 'Done'"></bzg-icon>
                            {{his.DescriptionStateBEX}}
                        </div>
                    </td>
                    <td class="bz-table__cell">
                        {{his.Username}}
                    </td>
                    <td class="bz-table__cell">
                        {{his.ImportTime | showDateFormat: 2}}
                    </td>
                    <td class="bz-table__cell">
                        {{his.ImportTime | showDateFormat: 3}}
                    </td>
                    <td class="bz-table__cell">
                        <div class="bmc-previous-processes__icon-action">
                            <bzg-icon [nameIcon]="'icon-view'" class="bmc-previous-processes__icon"
                                (click)="!isProcessing && viewSummary(his)"
                                [ngClass]="{'bmc-previous-processes__icon--disabled': isProcessing}"
                                [color]="his.DescriptionStateBEX == 'Done' && his.ImportPackageIntegrity && !isProcessing ? 'active' : 'disabled'"></bzg-icon>
                        </div>
                    </td>
                    <td class="bz-table__cell">
                        <div class="bmc-previous-processes__icon-action">
                            <bzg-icon [nameIcon]="'icon-download'" class="bmc-previous-processes__icon" *ngIf="!his.isDownloading"
                                 (click)="!isProcessing && downloadFile(his)"
                                 [ngClass]="{'bmc-previous-processes__icon--disabled': isProcessing}"
                                 [color]="his.DescriptionStateBEX == 'Done' && his.ImportPackageIntegrity && !isProcessing ? 'active' : 'disabled'"></bzg-icon>
                            <bzg-loading [size]="'s'" [bounce]="true" *ngIf="his.isDownloading">
                              {{'GLOBAL.DOWNLOADING' | translate}}</bzg-loading>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="bz-table-pagination">
        <bzg-paginator [pageSize]="pageSize" [totalItems]="history ? history.length : 10"
            (paginationChanged)="onPaginationEvent($event)" [pageSizeOptions]="[10, 30, 50, 100, 200, 500]">
        </bzg-paginator>
    </div>
</div>
<div class="bmc-previous-processes__loading" *ngIf="isLoading">
    <bzg-loading [size]="'s'">
        {{'DEPLOYMENT.LOADING_PREVIOUS_PROCESSES' | translate}}
    </bzg-loading>
</div>
